<div class="container-fluid px-3">
  <!-- Sheet Tabs Row -->
  <div class="row flex-shrink-0">
    <div class="col-12 position-relative d-flex mt-2 mb-2">
      <!-- Scrollable sheets container -->
      <div class="sheets-container overflow-auto flex-grow-1">
        <div class="d-flex align-items-center" style="min-height: 38px;">
          <div class="dropdown me-2" *ngFor="let sheet of sheets; let i = index" ngbDropdown [placement]="'bottom-start'" [open]="sheet.showDropDown || false">
            <button class="btn bg-light border rounded-top text-truncate position-relative"
                    type="button"
                    id="sheetButton_{{ i }}"
                    [class.bg-white]="sheet.loaded"
                    (click)="switchSheet(sheet)"
                    style="min-width: 120px; height: 38px; padding-right: 28px;">
              <span *ngIf="!sheet.isSheetNameEdit" class="text-truncate d-block text-secondary">{{ getSheetName(sheet) || 'Sheet ' + (i + 1) }}</span>
              <input class="form-control form-control-sm py-0 sheet-rename-input"
                     *ngIf="sheet.isSheetNameEdit"
                     [(ngModel)]="sheet.editedSheetName"
                     (focusout)="stopEditingSheet(sheet)"
                     (click)="$event.stopPropagation()" />
              <span class="dropdown-toggle position-absolute end-0 top-50 translate-middle-y pe-none me-2"></span>
            </button>
            <!-- Dropdown menu -->
            <div class="dropdown-menu shadow-sm position-fixed" ngbDropdownMenu style="z-index: 1050;">
              <button class="dropdown-item" (click)="editSheetName(sheet)">
                <i class="bi bi-pencil me-2"></i>Rename sheet
              </button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item text-danger" (click)="openDeleteModal(sheet.id)">
                <i class="bi bi-trash me-2"></i>Delete sheet
              </button>
            </div>
          </div>
        </div>

        <!-- Vertical separator and action buttons -->
        <div class="position-absolute end-0 top-0 h-100 d-flex align-items-center" style="margin-top: 0;">
          <!-- Fixed action buttons -->
          <div class="d-flex gap-2 bg-white px-2">
            <button class="btn btn-light" 
                    style="height: 38px; line-height: 24px; background-color: white;" 
                    (click)="openDownloadModal()"
                    [ngbTooltip]="'Download sheet data as Excel file or CSV'"
                    triggers="hover">
              <i class="bi bi-download"></i>
            </button>
            <!-- <button class="btn btn-light" style="height: 38px; line-height: 24px; background-color: white;" (click)="cleanGrid()">
              <i class="bi bi-eraser"></i>
            </button> -->
            <button class="btn btn-light" 
                    style="height: 38px; line-height: 24px; background-color: white;" 
                    (click)="transposeGrid()"
                    (mouseenter)="isTransposeHovered = true"
                    (mouseleave)="isTransposeHovered = false"
                    [ngbTooltip]="'Switch between row and column orientation'"
                    triggers="hover">
              <img [src]="isTransposeHovered ? transposeAnimatedImage : transposeStaticImage" 
                   alt="Transpose" 
                   style="width: 24px; height: 24px;">
            </button>
            <!-- Hide QA Info Button for now till the BE is ready-->
            <!-- <app-document-qa-info
              *ngIf="showQaInfo"
              [tableId]="activeTable"
              [active]="qaActive"
              [disabled]="qaDisabled"
              [isDatasetView]="isDatasetView"
            ></app-document-qa-info> -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Grid Row -->
  <div class="row flex-grow-1">
    <div class="col-12" style="height: calc(100vh - 155px);">
      <div class="ag-theme-quartz">
        <ag-grid-angular
          #agGrid
          class="h-100 w-100"
          [rowData]="rowData"
          [columnDefs]="colDefs"
          [defaultColDef]="defaultColDef"
          [gridOptions]="gridOptions"
          [theme]="theme"
          (cellClicked)="onCellClicked($event)"
          (cellDoubleClicked)="onCellDoubleClicked($event)"
          (cellValueChanged)="onCellValueChanged($event)"
          (bodyScroll)="onBodyScroll($event)"
          [overlayNoRowsTemplate]="noRowsTemplate"
          >
        </ag-grid-angular>

        <div
          #cellPopup
          *ngIf="cellPopupVisible"
          class="cell-info-popup"
          [class.popup-above]="isPopupAtBottom"
          [class.popup-below]="!isPopupAtBottom"
          [ngStyle]="cellPopupStyle"
          (click)="$event.stopPropagation()"
        >
          <div class="d-flex justify-content-between align-items-center mb-1">
            <div class="small text-muted">
              {{ cellPopupData.colHeader || cellPopupData.colField }}
            </div>
            <button
              type="button"
              class="btn-close btn-sm"
              aria-label="Close"
              (click)="closeCellPopup()"
            ></button>
          </div>
          <div class="cell-info-value">
            {{ cellPopupData.value }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete Sheet Modal -->
<ng-template #deleteSheetModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Delete Sheet</h4>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to delete this sheet?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-danger" (click)="deleteSheet(selectedSheetToDelete); modal.close()">Delete</button>
  </div>
</ng-template>

<!-- Download Modal -->
<ng-template #downloadModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Download</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modalService.dismissAll()"></button>
  </div>
  <div class="modal-body">
    <div class="d-flex flex-column gap-2">
      <button class="btn btn-primary" [disabled]="downloadLoading.xlsx" (click)="downloadXlsx()">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="downloadLoading.xlsx"></span>
        Download XLSX
      </button>
      <button class="btn btn-primary" [disabled]="downloadLoading.csv" (click)="downloadCsv()">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="downloadLoading.csv"></span>
        Download CSV
      </button>
    </div>
  </div>
</ng-template>